<section id="testimonials" class="testimonials">
  <div class="container" data-aos="fade-up">
    <owl-carousel-o [options]="customOptions">
      <ng-template carouselSlide>
        <div class="testimonial-item">
          <p>
            <i class="bx bxs-quote-alt-left quote-icon-left"></i>
            Art brings real beauty into all of our lives. The creativity and imagination our North Texas students bring to their artwork is astounding. I’m honored that the agency can provide our young artists with an opportunity to show everyone the wonder and brilliance of their work.
            <i class="bx bxs-quote-alt-right quote-icon-right"></i>
          </p>
          <h3>Nadine S. Lee, President & Chief Executive Officer</h3>
          <h4>Dallas Area Rapid Transit (DART)</h4>
        </div>
      </ng-template>
    </owl-carousel-o>
  </div>
</section>

